import PrototypeStudioLayout from '@shared/PrototypeStudioLayout';
import Loading from '@shared/Loading';
import { Size2MixTabs, NetworkShell, TEST_PUC_NETWORK, TOPOLOGY_REF_TABS, useSize2MixRefNavigation, type TopologyRefTabId } from '@shared/size2mix-shell';
import type { PrototypeMeta } from '@shared/discoverPrototypes';
import { useTopology } from './hooks';
import ParametersTab from './ParametersTab';

export const meta: PrototypeMeta = {
    title: 'Référence — Topologie › Paramètres',
    description:
        "Référence fidèle à la production de Réseau › Topologie › Paramètres (réseau test PUC) : caractéristiques de fonctionnement, profils simples, critères de dimensionnement et catalogue de canalisations.",
    tags: ['network', 'form', 'reference'],
    author: 'dv5886',
    status: 'reference',
    category: 'topology/parameters',
    createdAt: '2026-10-20',
};

export default function RefTopologyParameters() {
    const nav = useSize2MixRefNavigation();
    const { data, isLoading } = useTopology();

    return (
        <PrototypeStudioLayout title={meta.title}>
            <NetworkShell network={TEST_PUC_NETWORK} activePage="topology" onNavigate={nav.onNetworkNavigate} onPrimaryNavigate={nav.onPrimaryNavigate}>
                <Size2MixTabs<TopologyRefTabId> tabs={TOPOLOGY_REF_TABS} activeId="parameters" onChange={(id) => nav.goTo(TOPOLOGY_REF_TABS.find((t) => t.id === id)!.target)} />
                <div style={{ padding: '0 16px 16px' }}>
                    {isLoading || !data ? <Loading text="Chargement de la topologie" scale="md" /> : <ParametersTab parameters={data.parameters} />}
                </div>
            </NetworkShell>
        </PrototypeStudioLayout>
    );
}
